import React, { useEffect } from "react";
import { Select } from "antd";
import { useListPlatformsQuery } from "../redux/Api/PlatformApiSlice";
import Loader from "../pages/pages/loader";
import { toast } from "react-toastify";

const PlatformsDropdown = ({
  onChange,
  onBlur,
  value,
  multi = true,
  className = "",
  isAll = false,
}) => {
  const {
    data: platforms,
    isLoading,
    error,
  } = useListPlatformsQuery({
    expand: ["last_updated_by"].join(","),
    page: "*",
    ordering: "-id",
  });
  let options = [];
  if (platforms) {
    options = platforms?.results?.map((item) => {
      return {
        label: item.platform_name,
        value: item.id,
      };
    });
    if (isAll) {
      options = [{ label: "All Platforms", value: "*" }, ...options];
    }
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat();
      errorMessages.forEach((message) => {
        toast.error(message);
      });
    }
  }, [error]);

  return (
    <div>
      <Loader isLoading={isLoading} />
      <label className="form-label">Platform</label>
      <Select
        className={className}
        mode={multi ? "multiple" : ""}
        allowClear
        style={{
          width: "100%",
        }}
        optionFilterProp="label"
        loading={isLoading}
        placeholder="Please select"
        onBlur={onBlur}
        value={value}
        onChange={onChange}
        options={options}
      />
    </div>
  );
};

export default PlatformsDropdown;
